import React, { Component } from 'react'
import { Input } from '@tinper/next-ui'
import hocWithBaseElementWrap from '@utils/hocWithBaseElementWrap';
import request from 'ynf-core-engine/request';
import { isDesign, getDesignStyle, getFieldId } from '../../utils/tool'
import { observer } from "mobx-react";
import './style/index.less'
// 自动编码生成的组件，目前由后端进行编码生成，回填给此组件，以后考虑自发去请求生成编码。
// inputCode手工编号，即：不会自动生成编码。
// inputEdit手动可改，即：在自动生成编码的基础上允许修改。
const AUTO_CODE_DEFAULT_VALUE = true;

class Code extends Component {
  // 1、按照isCoded判断是否调用接口 - 在add模式下 -
  // 2、按照接口返回值 - 是自动还是手动 - 判断disabled
  // 3、按照组件别名，更新框架disabled的值，组件按照props渲染

  state = {
    isDisabled: this.props.disabled,
    lastDisabled: false,
    isAutoCode: false,
  }

  componentDidMount () {
    const { renderEnv, readOnly = false, disabled = '' } = this.props
    if (!(!isDesign(renderEnv) && readOnly)) {
      this.getDisableByCodeRule(disabled)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.disabled !== nextProps.disabled || this.props.readOnly !== nextProps.readOnly) {
      this.setState({ isDisabled : '' })
      const { renderEnv, readOnly = false } = nextProps
      if (!(!isDesign(renderEnv) && readOnly)) {
        this.getDisableByCodeRule(nextProps.disabled)
      }
    }
  }

  isAutoCode = (value) => {
    // billNumNode = 0是手动编码 - 1是自动编码
    return value === 1;
  }

  checkResult = (result) => {
    if (!result || !result.data) {
      const { pageStore = {} } = this.props
      const { rootStore } = pageStore
      rootStore?.utils.message.danger(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80089', '调用编码接口findYpdByBillNum异常'))
      return false;
    }
    return true;
  }

  /**
   * @returns 自动编码服务 {
   *  ① 设置为自动编码时，以自动编码服务的disabled状态为准
   *  ② 设置为手动编码时，接收props的disabled状态
   * }
   */
  getDisableByCodeRule = async (propsDisabled) => {
    this.setState({ isDisabled: this.getDisableFromRequest(propsDisabled) || propsDisabled })
  }

  getDisableFromRequest = (propsDisabled) => {
    const { renderEnv, pageStore } = this.props
    const { isDisabled } = this.state; // 作用：更新视图
    let cache = pageStore?.pageCache.getValue(pageStore?.query.busiObj)
    if (typeof (cache) == 'undefined') {
      if (!isDesign(renderEnv)) {
        this.loadCodeTypeToCache(propsDisabled);
      }
      pageStore?.pageCache.setValue(pageStore?.query.busiObj, 999)
      this.setState({ isDisabled: AUTO_CODE_DEFAULT_VALUE });
      return AUTO_CODE_DEFAULT_VALUE;
    }
    const cacheState = this.isAutoCode(cache) || propsDisabled
    this.setState({ isDisabled: cacheState });
    return cacheState;
  }

  // 获取编码规则 -
  loadCodeTypeToCache = async (propsDisabled) => {
    const { pageStore } = this.props;
    const res = await request({
      method: 'get',
      url: `/mdf-node/qtmProxy/ypd/bill/findYpdByBillNum?busiObj=${pageStore?.query?.busiObj}&domainKey=${pageStore?.query?.domainKey}&serviceCode=${pageStore?.query?.serviceCode}`
    })
    if (!this.checkResult(res)) {
      return;
    }
    pageStore?.pageCache.setValue(pageStore?.query.busiObj, res.data.billnumMode)
    // 手动编码-先根据外部状态【比如:主组织】判断，再按照编码规则
    const isAutoCode = this.isAutoCode(res.data.billnumMode);
    this.setState({ isDisabled: isAutoCode || propsDisabled, isAutoCode: isAutoCode });
  }

  onChange = (val) => {
    this.props?.onChange(val)
  }

  render() {
    const { renderEnv, visible = true, readOnly = false, ...otherProps } = this.props
    const { isAutoCode } = this.state;
    if (!visible) {
      return null;
    }
    /* —————————————————————— value显示 浏览态 —————————————————————— */
     if (!isDesign(renderEnv) && readOnly) {
      return formatter(this.props);
    }
    return (
      <Input
        className={`ynf-code ${getDesignStyle(renderEnv)}`}
        fieldid={`${getFieldId(this.props)}`}
        {...otherProps}
        placeholder={isAutoCode ? lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B86EF2404A00006', '自动生成无需输入') : ''}
        disabled={this.state.isDisabled}
        onChange={this.onChange} />
    )
  }
}

function formatter(props) {
  const { value = "--" } = props
  return <div className="codeShowAll">{ value || "--" }</div>
}

export default hocWithBaseElementWrap(observer(Code))
